﻿import config from "../config"
const baseUrl = config.base_url + "excel/"
export default {
    uploadTreeExcel: {
        url:  baseUrl + "uploadTreeExcel/{organId}/{areaId}",
        type: "post",
    },
    uploadTreeExcel2: {
        url:  baseUrl + "uploadTreeExcel2/{organId}/{areaId}",
        type: "post",
    },
    uploadTreeBlueRegion: {
        url:  config.base_url + "blueRegion/upload/{organId}",
        type: "post",
    }
}

